import { render, staticRenderFns } from "./LandingPageHeader.vue?vue&type=template&id=684f0032"
import script from "./LandingPageHeader.vue?vue&type=script&lang=ts"
export * from "./LandingPageHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports